import script from "./OrganisationKpiConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganisationKpiConfig.vue?vue&type=script&setup=true&lang=js"

import "./OrganisationKpiConfig.vue?vue&type=style&index=0&id=5e1a53f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e1a53f0"]])

export default __exports__